import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  FormGroup,
  Button,
  Label,
  Form,
  FormFeedback,
} from "reactstrap";
import loginImg from "../assets/images/loginimg.png";
import Background from "../assets/images/paygovbackground.jpg";
import { FORGOT_PASSWORD_PATH } from "../utils/AppRoutes";
import { Link, useHistory } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import { login } from "../redux/actions";
import { useFormik } from "formik";
import * as Yup from "yup";
import CustomLoader from "./common/CustomLoader";
import Axios from 'axios';
import Swal from "sweetalert2";
import { getAlertToast} from "../utils/functions/CustomFunctions";
import {
  LOGIN_URL, ALL_AGENCY_LIST
} from "../utils/APIEndpoints";
import BackArrow from "../assets/images/back arrow.svg";

const validationSchema = Yup.object({
  email: Yup.string()
    .trim()
    .required("Email is required")
    .email("Enter valid email"),
  password: Yup.string().trim().required("Password is required"),
});

const Signin = (props) => {
  const reduxState = useSelector((state) => state.LoginForm);
  // const { loading = false } = reduxState;

  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [isPasswordType, setPasswordInputType] = useState(true);

  const togglePasswordType = () => {
    setPasswordInputType(!isPasswordType);
  };

  const {
    handleSubmit,
    handleChange,
    handleBlur,
    values,
    errors,
    touched,
    setFieldTouched,
  } = useFormik({
    initialValues: {
      email: "",
      password: "",
      agencyId: "",
    },
    validationSchema,
    onSubmit(values) {
      props.login(values, history);
    },
  });

  const [isOpen, setIsOpen] = useState(false);
  const [list, setList] = useState([]);
  const toggle = () => setIsOpen(!isOpen);
  const [authFlag, setAuthFlag] = useState(false);
  const [isFirstTimeLogin, setIsFirstTimeLogin] = useState(false);
  const [isAdminPortal, setIsAdminPortal] = useState(false);
  const [isAgencyPortal, setIsAgencyPortal] = useState(false);
  console.log('getalll agency---sfdfgfhghgjhhkjklffffffffffffffffffffffffffffffffff--', LOGIN_URL);
  

  const getAllAgency = async () => {
    console.log('getalll agency-----');
     const response = await Axios.post(ALL_AGENCY_LIST, { 
      count: 10,
        offset: 0,
        agencyName: "",
        email: values.email,
    });
           console.log(response.data, '--response.data');
           const { status, message: resMessage } = response.data;
           if (status === "Success") {
             const { data } = response.data;
             setList(data);
             setIsFirstTimeLogin(false);
             } else {
                     Swal.fire(getAlertToast("error", resMessage));
                   }
  };
  const loginUser = async () => {
  console.log('login user agency-----, values', values);
    getAllAgency();
  try {
    // Making the API call using async/await
    const response = await Axios.post(LOGIN_URL, { 
      email: values.email,
      password: values.password,
      isFirstLogin : true
    });

    console.log(response.data, '--response.data');
    
    const { status, message: resMessage } = response.data;

    // Check if the login is successful
    if (status === "Success") {
      const { isFirstTimeLogin, isAdmin, isAgency } = response.data;
      setIsAdminPortal(isAdmin);   
      setIsAgencyPortal(isAgency);
      setIsFirstTimeLogin(isFirstTimeLogin);
      setAuthFlag(true);
    } else {
      // Show error message if status is not Success
      Swal.fire(getAlertToast("error", resMessage));
    }
  } catch (error) {
    // Handle any error from the API call
    if (error.response) {
      const { data } = error.response;
      Swal.fire(getAlertToast("error", data.message));
    } else {
      // In case the error doesn't have a response (e.g., network issues)
      Swal.fire(getAlertToast("error", "Something went wrong!"));
    }
    }
     setLoading(false);
};
 const backToSigin = () => {
    setAuthFlag(false);
  };
  const AgencyLogin = async () => {
    console.log('agency id-----', values);
    if (values.agencyId === "") {
     setLoading(false);
    Swal.fire(getAlertToast("error", "Please select your agency"));
    } else {
       setLoading(false);
    props.login(values, history);
    }
   
}
  const AdminLogin = async () => {
    console.log('admin id-----', values);
    values.isAdminLogin = 1;
    props.login(values, history);
}
  return (
    <div className="loginbg" style={{ backgroundImage: `url(${Background})` }}>
        <Container style={{ marginTop: "1rem" }}>
        <Row>
      
          {authFlag === false ? (
            <Col sm="12" md={{ size: 12 }}>
              <Row>
                <Col
                  // xs="12"
                  lg={6}
                  // md="6"
                  xs={12}
                  md={6}
                  className="loginbg-color xs-12"
                >
                  <img src={loginImg} className="w-100" />
                </Col>
                <Col
                  xs={12}
                  lg={6}
                  md={6}
                  className="bg-white p-4 pt-5 pb-5 xs-12"
                >
                  <h5 className="mb-1">Sign In</h5>
                  <p className="mb-4">
                    Welcome back, please sign in to your account.
                  </p>
                  <Form>
                    {/* <Form form="true" onSubmit={handleSubmit}> */}
                    <FormGroup>
                      <Label for="email">Email</Label>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="far fa-envelope" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          type="email"
                          name="email"
                          id="email"
                          placeholder="Enter Email"
                          invalid={errors.email && touched.email ? true : false}
                          onChange={(event) => {
                            setFieldTouched("email", true);
                            handleChange(event);
                          }}
                          value={values.email}
                        />
                        <FormFeedback>
                          {errors.email && touched.email ? errors.email : ""}
                        </FormFeedback>
                      </InputGroup>
                    </FormGroup>

                    <FormGroup>
                      <Label for="password">Password</Label>
                      <InputGroup>
                        <Input
                          type={isPasswordType ? "password" : "text"}
                          name="password"
                          id="password"
                          placeholder="Enter Password"
                          invalid={
                            errors.password && touched.password ? true : false
                          }
                          onChange={(event) => {
                            setFieldTouched("password", true);
                            handleChange(event);
                          }}
                          value={values.password}
                        />
                        <InputGroupAddon addonType="append">
                          <InputGroupText
                            onClick={togglePasswordType}
                            style={{ cursor: "pointer" }}
                          >
                            {isPasswordType ? (
                              <i className="fas fa-eye-slash" />
                            ) : (
                              <i className="fas fa-eye" />
                            )}
                          </InputGroupText>
                        </InputGroupAddon>
                        <FormFeedback>
                          {errors.password && touched.password
                            ? errors.password
                            : ""}
                        </FormFeedback>
                      </InputGroup>
                    </FormGroup>
                    <div className="mt-5">
                      <Link to={FORGOT_PASSWORD_PATH}>Forgot Password?</Link>
                            <Button
                              className="f-r"
                              onClick={async () => { 
                                // if (!loading) {
                                setLoading(true);
                                  await loginUser();
                                // }
                              }}
                              color="primary"
                              disabled={loading}
                            >
                        {loading ? <CustomLoader loading={loading} /> : <div></div>}
                        Sign In
                            </Button>
                    </div>
                  </Form>
                </Col>
              </Row>
            </Col>
      
          ) : (
              // {isAgency && PassFlag ? (
                <Col sm="12" md={{ size: 12 }}>
              <Row>
                <Col
                  // xs="12"
                  lg={6}
                  // md="6"
                  xs={12}
                  md={6}
                  className="loginbg-color xs-12"
                >
                  <img src={loginImg} className="w-100" />
                </Col>
                <Col
                  xs={12}
                  lg={6}
                  md={6}
                  className="bg-white p-4 pt-5 pb-5 xs-12"
                  >
                    {isAdminPortal ? (
                      <>
                        <br></br>
                        <br></br>
                        <div>
                    <Button color="primary" block onClick={AdminLogin}>
                      {loading && <CustomLoader />} Login to the admin
                      portal
                          </Button>
                          </div>
                        <br />
                    {/* <br /> */}
                  </>
                ) : (
                  <></>
                )}
                    {isAdminPortal && isAgencyPortal ? (
                       <div
                    style={{
                      position: "relative",
                      width: "100%",
                    }}
                    >
                    <hr
                      style={{ width: "100%", border: "1px solid #c8c0c0" }}
                    />
                    <p
                      style={{
                        position: "absolute",
                        left: "0",
                        right: "0",
                        textAlign: "center",
                        top: "-11px",
                      }}
                    >
                      <span
                        style={{
                          backgroundColor: "#f9f9f9",
                          padding: "5px 10px",
                        }}
                      >
                        Or
                      </span>
                    </p>
                    </div>
                ) : (<></>)}
                    {/* <br/> */}
                    {isAgencyPortal ? (
                      <Form>
                        <FormGroup>
                          <Label for="exampleEmail">Agency</Label>
                          <Input
                            type="select"
                            onBlur={handleBlur}
                            name="agencyId"
                            values={values.agencyId}
                            invalid={
                              touched.agencyId && errors.agencyId ? true : false
                            }
                            onChange={handleChange}
                            id="exampleEmail"
                            placeholder="Select your agency"
                          >
                            <option value="">Select your Agency</option>
                            {list &&
                              list.map((i) => (
                                <option key={i.agencyId} value={i.agencyId}>
                                  {i.agencyName}
                                </option>
                              ))}
                          </Input>
                          <FormFeedback>
                            {touched.agencyId && errors.agencyId
                              ? errors.agencyId
                              : ""}
                          </FormFeedback>
                        </FormGroup>

                        <Button color="primary" block onClick={async () => {
                          setLoading(true);
                          AgencyLogin();
                        }
                        }>
                          {loading ? <CustomLoader loading={loading} /> : <div></div>}
                          SIGN IN
                        </Button>
                        <div className="top-btn" style={{ textAlign: "center" }}>
                          <img
                            alt=""
                            src={BackArrow}
                            style={{
                              marginRight: "1px !important",
                              marginTop: "-1px !important",
                            }}
                          />

                          <Button
                            style={{
                              backgroundColor: "white",
                              borderColor: "white",
                              color: "black",
                            }}
                            onClick={backToSigin}
                          >
                            Back
                          </Button>
                        </div>
                      </Form>
                    ) : (
                  <></>
                )}
                  </Col>
                </Row>
                </Col>
          )}
            </Row>
        </Container>
    </div>
  );
};

const getState = (state) => {
  return {
    loggedUserData: state.login,
  };
};

export default connect(getState, {
  login,
})(Signin);
